"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_i18next_1 = require("react-i18next");
var usePageTitle = function (title) {
    var t = (0, react_i18next_1.useTranslation)().t;
    (0, react_1.useEffect)(function () {
        document.title = "".concat(title, " \u2022 ").concat(t('prism-header:culture-cloud'));
    }, [title, t]);
};
exports.default = usePageTitle;
//# sourceMappingURL=index.js.map